module.exports = __webpack_public_path__ + "landing_slider_fourth_slide_1440х798.e157784.jpg";